/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  AnkaufPriceStageRequest,
  AnkaufTierRequest,
  ApiEnvelopeAnkaufTransactionsResponse,
  ApiEnvelopeIReadOnlyListSellbotJournalEntryDto,
  ApiEnvelopeInventoryStorageItemsDto,
  ApiEnvelopeItemStackDto,
  ApiEnvelopeSellbotActivityResponse,
  ApiEnvelopeSellbotConfigDto,
  ApiEnvelopeSellbotCustomersResponse,
  ApiEnvelopeSellbotDispatchDto,
  ApiEnvelopeSellbotEmptyDto,
  ApiEnvelopeSellbotIdDto,
  ApiEnvelopeSellbotOfferImportResultDto,
  ApiEnvelopeSellbotOverviewDto,
  ApiEnvelopeSellbotSelfTestStepsResponse,
  ApiEnvelopeSellbotStatsDto,
  ApiEnvelopeSellbotTransactionEntryDto,
  ApiEnvelopeSellbotTransactionsResponse,
  ApiEnvelopeSellbotWizardDiffResponseDto,
  ItemMatchRuleRequest,
  ProblemDetails,
  SellbotBundleRequest,
  SellbotCaptureHomeRequest,
  SellbotConfigRequest,
  SellbotCreateFolderRequest,
  SellbotCreateOfferRequest,
  SellbotEnabledRequest,
  SellbotExportStatsParams,
  SellbotGetActivityParams,
  SellbotGetAnkaufTransactionsParams,
  SellbotGetStatsParams,
  SellbotGetTransactionsParams,
  SellbotImportOffersBody,
  SellbotLimitRequest,
  SellbotMoveTreeItemRequest,
  SellbotOfferCompressedListingRequest,
  SellbotOfferNoteRequest,
  SellbotOfferStockCacheRequest,
  SellbotOfferUnlistedRequest,
  SellbotRenameFolderRequest,
  SellbotRulePreviewRequest,
  SellbotSearchCustomersParams,
  SellbotTierRequest,
  SellbotWizardRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type sellbotGetConfigResponse200 = {
  data: ApiEnvelopeSellbotConfigDto
  status: 200
}

export type sellbotGetConfigResponseSuccess = (sellbotGetConfigResponse200) & {
  headers: Headers;
};
;

export type sellbotGetConfigResponse = (sellbotGetConfigResponseSuccess)

export const getSellbotGetConfigUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/config`
}

export const useSellbotGetConfigHook = (): (botId: string, options?: RequestInit) => Promise<sellbotGetConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGetConfigUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotUpsertConfigResponse200 = {
  data: ApiEnvelopeSellbotConfigDto
  status: 200
}

export type sellbotUpsertConfigResponseSuccess = (sellbotUpsertConfigResponse200) & {
  headers: Headers;
};
;

export type sellbotUpsertConfigResponse = (sellbotUpsertConfigResponseSuccess)

export const getSellbotUpsertConfigUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/config`
}

export const useSellbotUpsertConfigHook = (): (botId: string,
    sellbotConfigRequest?: SellbotConfigRequest, options?: RequestInit) => Promise<sellbotUpsertConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotConfigRequest?: SellbotConfigRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpsertConfigUrl(botId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotConfigRequest)
  }
);
      }
  }


export type sellbotSetEnabledResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotSetEnabledResponseSuccess = (sellbotSetEnabledResponse200) & {
  headers: Headers;
};
;

export type sellbotSetEnabledResponse = (sellbotSetEnabledResponseSuccess)

export const getSellbotSetEnabledUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/enabled`
}

export const useSellbotSetEnabledHook = (): (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => Promise<sellbotSetEnabledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => {

        return customFetcher(getSellbotSetEnabledUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotEnabledRequest)
  }
);
      }
  }


export type sellbotSetActiveResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotSetActiveResponseSuccess = (sellbotSetActiveResponse200) & {
  headers: Headers;
};
;

export type sellbotSetActiveResponse = (sellbotSetActiveResponseSuccess)

export const getSellbotSetActiveUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/active`
}

export const useSellbotSetActiveHook = (): (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => Promise<sellbotSetActiveResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => {

        return customFetcher(getSellbotSetActiveUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotEnabledRequest)
  }
);
      }
  }


export type sellbotSetAnkaufEnabledResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotSetAnkaufEnabledResponseSuccess = (sellbotSetAnkaufEnabledResponse200) & {
  headers: Headers;
};
;

export type sellbotSetAnkaufEnabledResponse = (sellbotSetAnkaufEnabledResponseSuccess)

export const getSellbotSetAnkaufEnabledUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/ankauf-enabled`
}

export const useSellbotSetAnkaufEnabledHook = (): (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => Promise<sellbotSetAnkaufEnabledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => {

        return customFetcher(getSellbotSetAnkaufEnabledUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotEnabledRequest)
  }
);
      }
  }


export type sellbotSetQuoteEnabledResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotSetQuoteEnabledResponseSuccess = (sellbotSetQuoteEnabledResponse200) & {
  headers: Headers;
};
;

export type sellbotSetQuoteEnabledResponse = (sellbotSetQuoteEnabledResponseSuccess)

export const getSellbotSetQuoteEnabledUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/quote-enabled`
}

export const useSellbotSetQuoteEnabledHook = (): (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => Promise<sellbotSetQuoteEnabledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => {

        return customFetcher(getSellbotSetQuoteEnabledUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotEnabledRequest)
  }
);
      }
  }


export type sellbotSetPriceQueryEnabledResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotSetPriceQueryEnabledResponseSuccess = (sellbotSetPriceQueryEnabledResponse200) & {
  headers: Headers;
};
;

export type sellbotSetPriceQueryEnabledResponse = (sellbotSetPriceQueryEnabledResponseSuccess)

export const getSellbotSetPriceQueryEnabledUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/price-query-enabled`
}

export const useSellbotSetPriceQueryEnabledHook = (): (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => Promise<sellbotSetPriceQueryEnabledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => {

        return customFetcher(getSellbotSetPriceQueryEnabledUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotEnabledRequest)
  }
);
      }
  }


export type sellbotSetPublishToGrieferUtilsResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotSetPublishToGrieferUtilsResponseSuccess = (sellbotSetPublishToGrieferUtilsResponse200) & {
  headers: Headers;
};
;

export type sellbotSetPublishToGrieferUtilsResponse = (sellbotSetPublishToGrieferUtilsResponseSuccess)

export const getSellbotSetPublishToGrieferUtilsUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/publish-grieferutils`
}

export const useSellbotSetPublishToGrieferUtilsHook = (): (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => Promise<sellbotSetPublishToGrieferUtilsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => {

        return customFetcher(getSellbotSetPublishToGrieferUtilsUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotEnabledRequest)
  }
);
      }
  }


export type sellbotSetPublishToGrieferInfoResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotSetPublishToGrieferInfoResponseSuccess = (sellbotSetPublishToGrieferInfoResponse200) & {
  headers: Headers;
};
;

export type sellbotSetPublishToGrieferInfoResponse = (sellbotSetPublishToGrieferInfoResponseSuccess)

export const getSellbotSetPublishToGrieferInfoUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/publish-grieferinfo`
}

export const useSellbotSetPublishToGrieferInfoHook = (): (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => Promise<sellbotSetPublishToGrieferInfoResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotEnabledRequest?: SellbotEnabledRequest, options?: RequestInit) => {

        return customFetcher(getSellbotSetPublishToGrieferInfoUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotEnabledRequest)
  }
);
      }
  }


export type sellbotCreateOfferResponse200 = {
  data: ApiEnvelopeSellbotIdDto
  status: 200
}

export type sellbotCreateOfferResponseSuccess = (sellbotCreateOfferResponse200) & {
  headers: Headers;
};
;

export type sellbotCreateOfferResponse = (sellbotCreateOfferResponseSuccess)

export const getSellbotCreateOfferUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/offers`
}

export const useSellbotCreateOfferHook = (): (botId: string,
    sellbotCreateOfferRequest?: SellbotCreateOfferRequest, options?: RequestInit) => Promise<sellbotCreateOfferResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotCreateOfferRequest?: SellbotCreateOfferRequest, options?: RequestInit) => {

        return customFetcher(getSellbotCreateOfferUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotCreateOfferRequest)
  }
);
      }
  }


export type sellbotDeleteOfferResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotDeleteOfferResponseSuccess = (sellbotDeleteOfferResponse200) & {
  headers: Headers;
};
;

export type sellbotDeleteOfferResponse = (sellbotDeleteOfferResponseSuccess)

export const getSellbotDeleteOfferUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}`
}

export const useSellbotDeleteOfferHook = (): (botId: string,
    offerId: string, options?: RequestInit) => Promise<sellbotDeleteOfferResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string, options?: RequestInit) => {

        return customFetcher(getSellbotDeleteOfferUrl(botId,offerId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotCreateOfferFolderResponse200 = {
  data: ApiEnvelopeSellbotIdDto
  status: 200
}

export type sellbotCreateOfferFolderResponseSuccess = (sellbotCreateOfferFolderResponse200) & {
  headers: Headers;
};
;

export type sellbotCreateOfferFolderResponse = (sellbotCreateOfferFolderResponseSuccess)

export const getSellbotCreateOfferFolderUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/offer-folders`
}

export const useSellbotCreateOfferFolderHook = (): (botId: string,
    sellbotCreateFolderRequest?: SellbotCreateFolderRequest, options?: RequestInit) => Promise<sellbotCreateOfferFolderResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotCreateFolderRequest?: SellbotCreateFolderRequest, options?: RequestInit) => {

        return customFetcher(getSellbotCreateOfferFolderUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotCreateFolderRequest)
  }
);
      }
  }


export type sellbotRenameOfferFolderResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotRenameOfferFolderResponseSuccess = (sellbotRenameOfferFolderResponse200) & {
  headers: Headers;
};
;

export type sellbotRenameOfferFolderResponse = (sellbotRenameOfferFolderResponseSuccess)

export const getSellbotRenameOfferFolderUrl = (botId: string,
    folderId: string,) => {




  return `/api/sellbot/${botId}/offer-folders/${folderId}`
}

export const useSellbotRenameOfferFolderHook = (): (botId: string,
    folderId: string,
    sellbotRenameFolderRequest?: SellbotRenameFolderRequest, options?: RequestInit) => Promise<sellbotRenameOfferFolderResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    folderId: string,
    sellbotRenameFolderRequest?: SellbotRenameFolderRequest, options?: RequestInit) => {

        return customFetcher(getSellbotRenameOfferFolderUrl(botId,folderId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotRenameFolderRequest)
  }
);
      }
  }


export type sellbotDeleteOfferFolderResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotDeleteOfferFolderResponseSuccess = (sellbotDeleteOfferFolderResponse200) & {
  headers: Headers;
};
;

export type sellbotDeleteOfferFolderResponse = (sellbotDeleteOfferFolderResponseSuccess)

export const getSellbotDeleteOfferFolderUrl = (botId: string,
    folderId: string,) => {




  return `/api/sellbot/${botId}/offer-folders/${folderId}`
}

export const useSellbotDeleteOfferFolderHook = (): (botId: string,
    folderId: string, options?: RequestInit) => Promise<sellbotDeleteOfferFolderResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    folderId: string, options?: RequestInit) => {

        return customFetcher(getSellbotDeleteOfferFolderUrl(botId,folderId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotMoveOfferTreeItemResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotMoveOfferTreeItemResponseSuccess = (sellbotMoveOfferTreeItemResponse200) & {
  headers: Headers;
};
;

export type sellbotMoveOfferTreeItemResponse = (sellbotMoveOfferTreeItemResponseSuccess)

export const getSellbotMoveOfferTreeItemUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/offer-tree/move`
}

export const useSellbotMoveOfferTreeItemHook = (): (botId: string,
    sellbotMoveTreeItemRequest?: SellbotMoveTreeItemRequest, options?: RequestInit) => Promise<sellbotMoveOfferTreeItemResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotMoveTreeItemRequest?: SellbotMoveTreeItemRequest, options?: RequestInit) => {

        return customFetcher(getSellbotMoveOfferTreeItemUrl(botId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotMoveTreeItemRequest)
  }
);
      }
  }


export type sellbotUpdateOfferNoteResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotUpdateOfferNoteResponseSuccess = (sellbotUpdateOfferNoteResponse200) & {
  headers: Headers;
};
;

export type sellbotUpdateOfferNoteResponse = (sellbotUpdateOfferNoteResponseSuccess)

export const getSellbotUpdateOfferNoteUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/note`
}

export const useSellbotUpdateOfferNoteHook = (): (botId: string,
    offerId: string,
    sellbotOfferNoteRequest?: SellbotOfferNoteRequest, options?: RequestInit) => Promise<sellbotUpdateOfferNoteResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    sellbotOfferNoteRequest?: SellbotOfferNoteRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpdateOfferNoteUrl(botId,offerId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotOfferNoteRequest)
  }
);
      }
  }


export type sellbotUpdateOfferStockCacheResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotUpdateOfferStockCacheResponseSuccess = (sellbotUpdateOfferStockCacheResponse200) & {
  headers: Headers;
};
;

export type sellbotUpdateOfferStockCacheResponse = (sellbotUpdateOfferStockCacheResponseSuccess)

export const getSellbotUpdateOfferStockCacheUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/stock-cache`
}

export const useSellbotUpdateOfferStockCacheHook = (): (botId: string,
    offerId: string,
    sellbotOfferStockCacheRequest?: SellbotOfferStockCacheRequest, options?: RequestInit) => Promise<sellbotUpdateOfferStockCacheResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    sellbotOfferStockCacheRequest?: SellbotOfferStockCacheRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpdateOfferStockCacheUrl(botId,offerId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotOfferStockCacheRequest)
  }
);
      }
  }


export type sellbotUpdateOfferUnlistedResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotUpdateOfferUnlistedResponseSuccess = (sellbotUpdateOfferUnlistedResponse200) & {
  headers: Headers;
};
;

export type sellbotUpdateOfferUnlistedResponse = (sellbotUpdateOfferUnlistedResponseSuccess)

export const getSellbotUpdateOfferUnlistedUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/unlisted`
}

export const useSellbotUpdateOfferUnlistedHook = (): (botId: string,
    offerId: string,
    sellbotOfferUnlistedRequest?: SellbotOfferUnlistedRequest, options?: RequestInit) => Promise<sellbotUpdateOfferUnlistedResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    sellbotOfferUnlistedRequest?: SellbotOfferUnlistedRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpdateOfferUnlistedUrl(botId,offerId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotOfferUnlistedRequest)
  }
);
      }
  }


export type sellbotUpdateOfferCompressedListingResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotUpdateOfferCompressedListingResponseSuccess = (sellbotUpdateOfferCompressedListingResponse200) & {
  headers: Headers;
};
;

export type sellbotUpdateOfferCompressedListingResponse = (sellbotUpdateOfferCompressedListingResponseSuccess)

export const getSellbotUpdateOfferCompressedListingUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/compressed-listing`
}

export const useSellbotUpdateOfferCompressedListingHook = (): (botId: string,
    offerId: string,
    sellbotOfferCompressedListingRequest?: SellbotOfferCompressedListingRequest, options?: RequestInit) => Promise<sellbotUpdateOfferCompressedListingResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    sellbotOfferCompressedListingRequest?: SellbotOfferCompressedListingRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpdateOfferCompressedListingUrl(botId,offerId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotOfferCompressedListingRequest)
  }
);
      }
  }


export type sellbotExportOffersResponse200 = {
  data: Blob
  status: 200
}

export type sellbotExportOffersResponse404 = {
  data: ProblemDetails
  status: 404
}

export type sellbotExportOffersResponseSuccess = (sellbotExportOffersResponse200) & {
  headers: Headers;
};
export type sellbotExportOffersResponseError = (sellbotExportOffersResponse404) & {
  headers: Headers;
};

export type sellbotExportOffersResponse = (sellbotExportOffersResponseSuccess | sellbotExportOffersResponseError)

export const getSellbotExportOffersUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/offers/export`
}

export const useSellbotExportOffersHook = (): (botId: string, options?: RequestInit) => Promise<sellbotExportOffersResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotExportOffersUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotImportOffersResponse200 = {
  data: ApiEnvelopeSellbotOfferImportResultDto
  status: 200
}

export type sellbotImportOffersResponse400 = {
  data: ApiEnvelopeSellbotOfferImportResultDto
  status: 400
}

export type sellbotImportOffersResponse404 = {
  data: ApiEnvelopeSellbotOfferImportResultDto
  status: 404
}

export type sellbotImportOffersResponseSuccess = (sellbotImportOffersResponse200) & {
  headers: Headers;
};
export type sellbotImportOffersResponseError = (sellbotImportOffersResponse400 | sellbotImportOffersResponse404) & {
  headers: Headers;
};

export type sellbotImportOffersResponse = (sellbotImportOffersResponseSuccess | sellbotImportOffersResponseError)

export const getSellbotImportOffersUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/offers/import`
}

export const useSellbotImportOffersHook = (): (botId: string,
    sellbotImportOffersBody?: SellbotImportOffersBody, options?: RequestInit) => Promise<sellbotImportOffersResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotImportOffersBody?: SellbotImportOffersBody, options?: RequestInit) => {
        const formData = new FormData();
if(sellbotImportOffersBody?.file !== undefined) {
 formData.append(`file`, sellbotImportOffersBody.file);
 }
if(sellbotImportOffersBody?.dryRun !== undefined) {
 formData.append(`dryRun`, sellbotImportOffersBody.dryRun.toString())
 }

        return customFetcher(getSellbotImportOffersUrl(botId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);
      }
  }


export type sellbotCreateTierResponse200 = {
  data: ApiEnvelopeSellbotIdDto
  status: 200
}

export type sellbotCreateTierResponseSuccess = (sellbotCreateTierResponse200) & {
  headers: Headers;
};
;

export type sellbotCreateTierResponse = (sellbotCreateTierResponseSuccess)

export const getSellbotCreateTierUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/tiers`
}

export const useSellbotCreateTierHook = (): (botId: string,
    offerId: string,
    sellbotTierRequest?: SellbotTierRequest, options?: RequestInit) => Promise<sellbotCreateTierResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    sellbotTierRequest?: SellbotTierRequest, options?: RequestInit) => {

        return customFetcher(getSellbotCreateTierUrl(botId,offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotTierRequest)
  }
);
      }
  }


export type sellbotUpdateTierResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotUpdateTierResponseSuccess = (sellbotUpdateTierResponse200) & {
  headers: Headers;
};
;

export type sellbotUpdateTierResponse = (sellbotUpdateTierResponseSuccess)

export const getSellbotUpdateTierUrl = (botId: string,
    tierId: string,) => {




  return `/api/sellbot/${botId}/tiers/${tierId}`
}

export const useSellbotUpdateTierHook = (): (botId: string,
    tierId: string,
    sellbotTierRequest?: SellbotTierRequest, options?: RequestInit) => Promise<sellbotUpdateTierResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    tierId: string,
    sellbotTierRequest?: SellbotTierRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpdateTierUrl(botId,tierId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotTierRequest)
  }
);
      }
  }


export type sellbotDeleteTierResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotDeleteTierResponseSuccess = (sellbotDeleteTierResponse200) & {
  headers: Headers;
};
;

export type sellbotDeleteTierResponse = (sellbotDeleteTierResponseSuccess)

export const getSellbotDeleteTierUrl = (botId: string,
    tierId: string,) => {




  return `/api/sellbot/${botId}/tiers/${tierId}`
}

export const useSellbotDeleteTierHook = (): (botId: string,
    tierId: string, options?: RequestInit) => Promise<sellbotDeleteTierResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    tierId: string, options?: RequestInit) => {

        return customFetcher(getSellbotDeleteTierUrl(botId,tierId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotRenameBundleResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotRenameBundleResponseSuccess = (sellbotRenameBundleResponse200) & {
  headers: Headers;
};
;

export type sellbotRenameBundleResponse = (sellbotRenameBundleResponseSuccess)

export const getSellbotRenameBundleUrl = (botId: string,
    bundleId: string,) => {




  return `/api/sellbot/${botId}/bundles/${bundleId}`
}

export const useSellbotRenameBundleHook = (): (botId: string,
    bundleId: string,
    sellbotBundleRequest?: SellbotBundleRequest, options?: RequestInit) => Promise<sellbotRenameBundleResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    bundleId: string,
    sellbotBundleRequest?: SellbotBundleRequest, options?: RequestInit) => {

        return customFetcher(getSellbotRenameBundleUrl(botId,bundleId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotBundleRequest)
  }
);
      }
  }


export type sellbotRulePreviewResponse200 = {
  data: ApiEnvelopeItemStackDto
  status: 200
}

export type sellbotRulePreviewResponseSuccess = (sellbotRulePreviewResponse200) & {
  headers: Headers;
};
;

export type sellbotRulePreviewResponse = (sellbotRulePreviewResponseSuccess)

export const getSellbotRulePreviewUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/rule-preview`
}

export const useSellbotRulePreviewHook = (): (botId: string,
    sellbotRulePreviewRequest?: SellbotRulePreviewRequest, options?: RequestInit) => Promise<sellbotRulePreviewResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotRulePreviewRequest?: SellbotRulePreviewRequest, options?: RequestInit) => {

        return customFetcher(getSellbotRulePreviewUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotRulePreviewRequest)
  }
);
      }
  }


export type sellbotCreateRuleResponse200 = {
  data: ApiEnvelopeSellbotIdDto
  status: 200
}

export type sellbotCreateRuleResponseSuccess = (sellbotCreateRuleResponse200) & {
  headers: Headers;
};
;

export type sellbotCreateRuleResponse = (sellbotCreateRuleResponseSuccess)

export const getSellbotCreateRuleUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/rules`
}

export const useSellbotCreateRuleHook = (): (botId: string,
    offerId: string,
    itemMatchRuleRequest?: ItemMatchRuleRequest, options?: RequestInit) => Promise<sellbotCreateRuleResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    itemMatchRuleRequest?: ItemMatchRuleRequest, options?: RequestInit) => {

        return customFetcher(getSellbotCreateRuleUrl(botId,offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(itemMatchRuleRequest)
  }
);
      }
  }


export type sellbotApplyRulesResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotApplyRulesResponseSuccess = (sellbotApplyRulesResponse200) & {
  headers: Headers;
};
;

export type sellbotApplyRulesResponse = (sellbotApplyRulesResponseSuccess)

export const getSellbotApplyRulesUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/rules/apply`
}

export const useSellbotApplyRulesHook = (): (botId: string,
    offerId: string,
    sellbotWizardRequest?: SellbotWizardRequest, options?: RequestInit) => Promise<sellbotApplyRulesResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    sellbotWizardRequest?: SellbotWizardRequest, options?: RequestInit) => {

        return customFetcher(getSellbotApplyRulesUrl(botId,offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotWizardRequest)
  }
);
      }
  }


export type sellbotWizardDiffResponse200 = {
  data: ApiEnvelopeSellbotWizardDiffResponseDto
  status: 200
}

export type sellbotWizardDiffResponseSuccess = (sellbotWizardDiffResponse200) & {
  headers: Headers;
};
;

export type sellbotWizardDiffResponse = (sellbotWizardDiffResponseSuccess)

export const getSellbotWizardDiffUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/rules/wizard-diff`
}

export const useSellbotWizardDiffHook = (): (botId: string,
    sellbotWizardRequest?: SellbotWizardRequest, options?: RequestInit) => Promise<sellbotWizardDiffResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotWizardRequest?: SellbotWizardRequest, options?: RequestInit) => {

        return customFetcher(getSellbotWizardDiffUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotWizardRequest)
  }
);
      }
  }


export type sellbotUpdateRuleResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotUpdateRuleResponseSuccess = (sellbotUpdateRuleResponse200) & {
  headers: Headers;
};
;

export type sellbotUpdateRuleResponse = (sellbotUpdateRuleResponseSuccess)

export const getSellbotUpdateRuleUrl = (botId: string,
    offerId: string,
    ruleId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/rules/${ruleId}`
}

export const useSellbotUpdateRuleHook = (): (botId: string,
    offerId: string,
    ruleId: string,
    itemMatchRuleRequest?: ItemMatchRuleRequest, options?: RequestInit) => Promise<sellbotUpdateRuleResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    ruleId: string,
    itemMatchRuleRequest?: ItemMatchRuleRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpdateRuleUrl(botId,offerId,ruleId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(itemMatchRuleRequest)
  }
);
      }
  }


export type sellbotDeleteRuleResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotDeleteRuleResponseSuccess = (sellbotDeleteRuleResponse200) & {
  headers: Headers;
};
;

export type sellbotDeleteRuleResponse = (sellbotDeleteRuleResponseSuccess)

export const getSellbotDeleteRuleUrl = (botId: string,
    offerId: string,
    ruleId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/rules/${ruleId}`
}

export const useSellbotDeleteRuleHook = (): (botId: string,
    offerId: string,
    ruleId: string, options?: RequestInit) => Promise<sellbotDeleteRuleResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    ruleId: string, options?: RequestInit) => {

        return customFetcher(getSellbotDeleteRuleUrl(botId,offerId,ruleId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotGetTransactionsResponse200 = {
  data: ApiEnvelopeSellbotTransactionsResponse
  status: 200
}

export type sellbotGetTransactionsResponseSuccess = (sellbotGetTransactionsResponse200) & {
  headers: Headers;
};
;

export type sellbotGetTransactionsResponse = (sellbotGetTransactionsResponseSuccess)

export const getSellbotGetTransactionsUrl = (botId: string,
    params?: SellbotGetTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sellbot/${botId}/transactions?${stringifiedParams}` : `/api/sellbot/${botId}/transactions`
}

export const useSellbotGetTransactionsHook = (): (botId: string,
    params?: SellbotGetTransactionsParams, options?: RequestInit) => Promise<sellbotGetTransactionsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: SellbotGetTransactionsParams, options?: RequestInit) => {

        return customFetcher(getSellbotGetTransactionsUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotGetTransactionResponse200 = {
  data: ApiEnvelopeSellbotTransactionEntryDto
  status: 200
}

export type sellbotGetTransactionResponseSuccess = (sellbotGetTransactionResponse200) & {
  headers: Headers;
};
;

export type sellbotGetTransactionResponse = (sellbotGetTransactionResponseSuccess)

export const getSellbotGetTransactionUrl = (botId: string,
    transactionId: string,) => {




  return `/api/sellbot/${botId}/transactions/${transactionId}`
}

export const useSellbotGetTransactionHook = (): (botId: string,
    transactionId: string, options?: RequestInit) => Promise<sellbotGetTransactionResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    transactionId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGetTransactionUrl(botId,transactionId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotSearchCustomersResponse200 = {
  data: ApiEnvelopeSellbotCustomersResponse
  status: 200
}

export type sellbotSearchCustomersResponseSuccess = (sellbotSearchCustomersResponse200) & {
  headers: Headers;
};
;

export type sellbotSearchCustomersResponse = (sellbotSearchCustomersResponseSuccess)

export const getSellbotSearchCustomersUrl = (botId: string,
    params?: SellbotSearchCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sellbot/${botId}/customers?${stringifiedParams}` : `/api/sellbot/${botId}/customers`
}

export const useSellbotSearchCustomersHook = (): (botId: string,
    params?: SellbotSearchCustomersParams, options?: RequestInit) => Promise<sellbotSearchCustomersResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: SellbotSearchCustomersParams, options?: RequestInit) => {

        return customFetcher(getSellbotSearchCustomersUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotGetActivityResponse200 = {
  data: ApiEnvelopeSellbotActivityResponse
  status: 200
}

export type sellbotGetActivityResponseSuccess = (sellbotGetActivityResponse200) & {
  headers: Headers;
};
;

export type sellbotGetActivityResponse = (sellbotGetActivityResponseSuccess)

export const getSellbotGetActivityUrl = (botId: string,
    params?: SellbotGetActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sellbot/${botId}/activity?${stringifiedParams}` : `/api/sellbot/${botId}/activity`
}

export const useSellbotGetActivityHook = (): (botId: string,
    params?: SellbotGetActivityParams, options?: RequestInit) => Promise<sellbotGetActivityResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: SellbotGetActivityParams, options?: RequestInit) => {

        return customFetcher(getSellbotGetActivityUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotGetJournalResponse200 = {
  data: ApiEnvelopeIReadOnlyListSellbotJournalEntryDto
  status: 200
}

export type sellbotGetJournalResponseSuccess = (sellbotGetJournalResponse200) & {
  headers: Headers;
};
;

export type sellbotGetJournalResponse = (sellbotGetJournalResponseSuccess)

export const getSellbotGetJournalUrl = (botId: string,
    transactionId: string,) => {




  return `/api/sellbot/${botId}/transactions/${transactionId}/journal`
}

export const useSellbotGetJournalHook = (): (botId: string,
    transactionId: string, options?: RequestInit) => Promise<sellbotGetJournalResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    transactionId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGetJournalUrl(botId,transactionId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotGetOverviewResponse200 = {
  data: ApiEnvelopeSellbotOverviewDto
  status: 200
}

export type sellbotGetOverviewResponseSuccess = (sellbotGetOverviewResponse200) & {
  headers: Headers;
};
;

export type sellbotGetOverviewResponse = (sellbotGetOverviewResponseSuccess)

export const getSellbotGetOverviewUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/overview`
}

export const useSellbotGetOverviewHook = (): (botId: string, options?: RequestInit) => Promise<sellbotGetOverviewResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGetOverviewUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotGetStatsResponse200 = {
  data: ApiEnvelopeSellbotStatsDto
  status: 200
}

export type sellbotGetStatsResponseSuccess = (sellbotGetStatsResponse200) & {
  headers: Headers;
};
;

export type sellbotGetStatsResponse = (sellbotGetStatsResponseSuccess)

export const getSellbotGetStatsUrl = (botId: string,
    params?: SellbotGetStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sellbot/${botId}/stats?${stringifiedParams}` : `/api/sellbot/${botId}/stats`
}

export const useSellbotGetStatsHook = (): (botId: string,
    params?: SellbotGetStatsParams, options?: RequestInit) => Promise<sellbotGetStatsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: SellbotGetStatsParams, options?: RequestInit) => {

        return customFetcher(getSellbotGetStatsUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotExportStatsResponse200 = {
  data: Blob
  status: 200
}

export type sellbotExportStatsResponseSuccess = (sellbotExportStatsResponse200) & {
  headers: Headers;
};
;

export type sellbotExportStatsResponse = (sellbotExportStatsResponseSuccess)

export const getSellbotExportStatsUrl = (botId: string,
    params?: SellbotExportStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sellbot/${botId}/stats/export?${stringifiedParams}` : `/api/sellbot/${botId}/stats/export`
}

export const useSellbotExportStatsHook = (): (botId: string,
    params?: SellbotExportStatsParams, options?: RequestInit) => Promise<sellbotExportStatsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: SellbotExportStatsParams, options?: RequestInit) => {

        return customFetcher(getSellbotExportStatsUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotGetChamberStockResponse200 = {
  data: ApiEnvelopeInventoryStorageItemsDto
  status: 200
}

export type sellbotGetChamberStockResponseSuccess = (sellbotGetChamberStockResponse200) & {
  headers: Headers;
};
;

export type sellbotGetChamberStockResponse = (sellbotGetChamberStockResponseSuccess)

export const getSellbotGetChamberStockUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/chamber-stock`
}

export const useSellbotGetChamberStockHook = (): (botId: string, options?: RequestInit) => Promise<sellbotGetChamberStockResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGetChamberStockUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotRescanResponse200 = {
  data: ApiEnvelopeSellbotDispatchDto
  status: 200
}

export type sellbotRescanResponseSuccess = (sellbotRescanResponse200) & {
  headers: Headers;
};
;

export type sellbotRescanResponse = (sellbotRescanResponseSuccess)

export const getSellbotRescanUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/rescan`
}

export const useSellbotRescanHook = (): (botId: string, options?: RequestInit) => Promise<sellbotRescanResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotRescanUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type sellbotScanStockResponse200 = {
  data: ApiEnvelopeSellbotDispatchDto
  status: 200
}

export type sellbotScanStockResponseSuccess = (sellbotScanStockResponse200) & {
  headers: Headers;
};
;

export type sellbotScanStockResponse = (sellbotScanStockResponseSuccess)

export const getSellbotScanStockUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/scan-stock`
}

export const useSellbotScanStockHook = (): (botId: string, options?: RequestInit) => Promise<sellbotScanStockResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotScanStockUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type sellbotGetSelfTestStepsResponse200 = {
  data: ApiEnvelopeSellbotSelfTestStepsResponse
  status: 200
}

export type sellbotGetSelfTestStepsResponseSuccess = (sellbotGetSelfTestStepsResponse200) & {
  headers: Headers;
};
;

export type sellbotGetSelfTestStepsResponse = (sellbotGetSelfTestStepsResponseSuccess)

export const getSellbotGetSelfTestStepsUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/selftest/steps`
}

export const useSellbotGetSelfTestStepsHook = (): (botId: string, options?: RequestInit) => Promise<sellbotGetSelfTestStepsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGetSelfTestStepsUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotRunSelfTestResponse200 = {
  data: ApiEnvelopeSellbotDispatchDto
  status: 200
}

export type sellbotRunSelfTestResponseSuccess = (sellbotRunSelfTestResponse200) & {
  headers: Headers;
};
;

export type sellbotRunSelfTestResponse = (sellbotRunSelfTestResponseSuccess)

export const getSellbotRunSelfTestUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/selftest/run`
}

export const useSellbotRunSelfTestHook = (): (botId: string, options?: RequestInit) => Promise<sellbotRunSelfTestResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotRunSelfTestUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type sellbotCaptureHomeResponse200 = {
  data: ApiEnvelopeSellbotDispatchDto
  status: 200
}

export type sellbotCaptureHomeResponseSuccess = (sellbotCaptureHomeResponse200) & {
  headers: Headers;
};
;

export type sellbotCaptureHomeResponse = (sellbotCaptureHomeResponseSuccess)

export const getSellbotCaptureHomeUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/capture-home`
}

export const useSellbotCaptureHomeHook = (): (botId: string,
    sellbotCaptureHomeRequest?: SellbotCaptureHomeRequest, options?: RequestInit) => Promise<sellbotCaptureHomeResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotCaptureHomeRequest?: SellbotCaptureHomeRequest, options?: RequestInit) => {

        return customFetcher(getSellbotCaptureHomeUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotCaptureHomeRequest)
  }
);
      }
  }


export type sellbotRecordZoneDropPathResponse200 = {
  data: ApiEnvelopeSellbotDispatchDto
  status: 200
}

export type sellbotRecordZoneDropPathResponseSuccess = (sellbotRecordZoneDropPathResponse200) & {
  headers: Headers;
};
;

export type sellbotRecordZoneDropPathResponse = (sellbotRecordZoneDropPathResponseSuccess)

export const getSellbotRecordZoneDropPathUrl = (botId: string,
    zoneId: string,) => {




  return `/api/sellbot/${botId}/zones/${zoneId}/record-path`
}

export const useSellbotRecordZoneDropPathHook = (): (botId: string,
    zoneId: string, options?: RequestInit) => Promise<sellbotRecordZoneDropPathResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    zoneId: string, options?: RequestInit) => {

        return customFetcher(getSellbotRecordZoneDropPathUrl(botId,zoneId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type sellbotUpsertAnkaufTierResponse200 = {
  data: ApiEnvelopeSellbotIdDto
  status: 200
}

export type sellbotUpsertAnkaufTierResponseSuccess = (sellbotUpsertAnkaufTierResponse200) & {
  headers: Headers;
};
;

export type sellbotUpsertAnkaufTierResponse = (sellbotUpsertAnkaufTierResponseSuccess)

export const getSellbotUpsertAnkaufTierUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/ankauf-tier`
}

export const useSellbotUpsertAnkaufTierHook = (): (botId: string,
    offerId: string,
    ankaufTierRequest?: AnkaufTierRequest, options?: RequestInit) => Promise<sellbotUpsertAnkaufTierResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    ankaufTierRequest?: AnkaufTierRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpsertAnkaufTierUrl(botId,offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ankaufTierRequest)
  }
);
      }
  }


export type sellbotDeleteAnkaufTierResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotDeleteAnkaufTierResponseSuccess = (sellbotDeleteAnkaufTierResponse200) & {
  headers: Headers;
};
;

export type sellbotDeleteAnkaufTierResponse = (sellbotDeleteAnkaufTierResponseSuccess)

export const getSellbotDeleteAnkaufTierUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/ankauf-tier`
}

export const useSellbotDeleteAnkaufTierHook = (): (botId: string,
    offerId: string, options?: RequestInit) => Promise<sellbotDeleteAnkaufTierResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string, options?: RequestInit) => {

        return customFetcher(getSellbotDeleteAnkaufTierUrl(botId,offerId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotCreateAnkaufPriceStageResponse200 = {
  data: ApiEnvelopeSellbotIdDto
  status: 200
}

export type sellbotCreateAnkaufPriceStageResponseSuccess = (sellbotCreateAnkaufPriceStageResponse200) & {
  headers: Headers;
};
;

export type sellbotCreateAnkaufPriceStageResponse = (sellbotCreateAnkaufPriceStageResponseSuccess)

export const getSellbotCreateAnkaufPriceStageUrl = (botId: string,
    ankaufTierId: string,) => {




  return `/api/sellbot/${botId}/ankauf-tiers/${ankaufTierId}/stages`
}

export const useSellbotCreateAnkaufPriceStageHook = (): (botId: string,
    ankaufTierId: string,
    ankaufPriceStageRequest?: AnkaufPriceStageRequest, options?: RequestInit) => Promise<sellbotCreateAnkaufPriceStageResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    ankaufTierId: string,
    ankaufPriceStageRequest?: AnkaufPriceStageRequest, options?: RequestInit) => {

        return customFetcher(getSellbotCreateAnkaufPriceStageUrl(botId,ankaufTierId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ankaufPriceStageRequest)
  }
);
      }
  }


export type sellbotUpdateAnkaufPriceStageResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotUpdateAnkaufPriceStageResponseSuccess = (sellbotUpdateAnkaufPriceStageResponse200) & {
  headers: Headers;
};
;

export type sellbotUpdateAnkaufPriceStageResponse = (sellbotUpdateAnkaufPriceStageResponseSuccess)

export const getSellbotUpdateAnkaufPriceStageUrl = (botId: string,
    stageId: string,) => {




  return `/api/sellbot/${botId}/ankauf-stages/${stageId}`
}

export const useSellbotUpdateAnkaufPriceStageHook = (): (botId: string,
    stageId: string,
    ankaufPriceStageRequest?: AnkaufPriceStageRequest, options?: RequestInit) => Promise<sellbotUpdateAnkaufPriceStageResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    stageId: string,
    ankaufPriceStageRequest?: AnkaufPriceStageRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpdateAnkaufPriceStageUrl(botId,stageId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ankaufPriceStageRequest)
  }
);
      }
  }


export type sellbotDeleteAnkaufPriceStageResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotDeleteAnkaufPriceStageResponseSuccess = (sellbotDeleteAnkaufPriceStageResponse200) & {
  headers: Headers;
};
;

export type sellbotDeleteAnkaufPriceStageResponse = (sellbotDeleteAnkaufPriceStageResponseSuccess)

export const getSellbotDeleteAnkaufPriceStageUrl = (botId: string,
    stageId: string,) => {




  return `/api/sellbot/${botId}/ankauf-stages/${stageId}`
}

export const useSellbotDeleteAnkaufPriceStageHook = (): (botId: string,
    stageId: string, options?: RequestInit) => Promise<sellbotDeleteAnkaufPriceStageResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    stageId: string, options?: RequestInit) => {

        return customFetcher(getSellbotDeleteAnkaufPriceStageUrl(botId,stageId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotCreateLimitResponse200 = {
  data: ApiEnvelopeSellbotIdDto
  status: 200
}

export type sellbotCreateLimitResponseSuccess = (sellbotCreateLimitResponse200) & {
  headers: Headers;
};
;

export type sellbotCreateLimitResponse = (sellbotCreateLimitResponseSuccess)

export const getSellbotCreateLimitUrl = (botId: string,
    offerId: string,) => {




  return `/api/sellbot/${botId}/offers/${offerId}/limits`
}

export const useSellbotCreateLimitHook = (): (botId: string,
    offerId: string,
    sellbotLimitRequest?: SellbotLimitRequest, options?: RequestInit) => Promise<sellbotCreateLimitResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    offerId: string,
    sellbotLimitRequest?: SellbotLimitRequest, options?: RequestInit) => {

        return customFetcher(getSellbotCreateLimitUrl(botId,offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotLimitRequest)
  }
);
      }
  }


export type sellbotUpdateLimitResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotUpdateLimitResponseSuccess = (sellbotUpdateLimitResponse200) & {
  headers: Headers;
};
;

export type sellbotUpdateLimitResponse = (sellbotUpdateLimitResponseSuccess)

export const getSellbotUpdateLimitUrl = (botId: string,
    limitId: string,) => {




  return `/api/sellbot/${botId}/limits/${limitId}`
}

export const useSellbotUpdateLimitHook = (): (botId: string,
    limitId: string,
    sellbotLimitRequest?: SellbotLimitRequest, options?: RequestInit) => Promise<sellbotUpdateLimitResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    limitId: string,
    sellbotLimitRequest?: SellbotLimitRequest, options?: RequestInit) => {

        return customFetcher(getSellbotUpdateLimitUrl(botId,limitId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotLimitRequest)
  }
);
      }
  }


export type sellbotDeleteLimitResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotDeleteLimitResponseSuccess = (sellbotDeleteLimitResponse200) & {
  headers: Headers;
};
;

export type sellbotDeleteLimitResponse = (sellbotDeleteLimitResponseSuccess)

export const getSellbotDeleteLimitUrl = (botId: string,
    limitId: string,) => {




  return `/api/sellbot/${botId}/limits/${limitId}`
}

export const useSellbotDeleteLimitHook = (): (botId: string,
    limitId: string, options?: RequestInit) => Promise<sellbotDeleteLimitResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    limitId: string, options?: RequestInit) => {

        return customFetcher(getSellbotDeleteLimitUrl(botId,limitId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotGetAnkaufTransactionsResponse200 = {
  data: ApiEnvelopeAnkaufTransactionsResponse
  status: 200
}

export type sellbotGetAnkaufTransactionsResponseSuccess = (sellbotGetAnkaufTransactionsResponse200) & {
  headers: Headers;
};
;

export type sellbotGetAnkaufTransactionsResponse = (sellbotGetAnkaufTransactionsResponseSuccess)

export const getSellbotGetAnkaufTransactionsUrl = (botId: string,
    params?: SellbotGetAnkaufTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sellbot/${botId}/ankauf-transactions?${stringifiedParams}` : `/api/sellbot/${botId}/ankauf-transactions`
}

export const useSellbotGetAnkaufTransactionsHook = (): (botId: string,
    params?: SellbotGetAnkaufTransactionsParams, options?: RequestInit) => Promise<sellbotGetAnkaufTransactionsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: SellbotGetAnkaufTransactionsParams, options?: RequestInit) => {

        return customFetcher(getSellbotGetAnkaufTransactionsUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


